import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';

const defaultFormControlSx = {
  background: "#fff",
  width: 200,
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.87) !important",
  },
  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#f47803 !important",
    borderWidth: "1px !important",
  }
};
const defaultLabelSx = { background: "#fff" };
const defaultCheckboxSx = { "&.Mui-checked": { color: "#f47803ff" } };

/**
 * Plant filter dropdown — a tier above Machine Group. Dropped into every
 * screen that renders `useMachineGroups`'s Machine Group filter, right
 * before it, whenever that hook's `showPlantFilter` is true (PMI only,
 * once 2+ Plants are configured). Defaults mirror the plain MUI-outlined
 * Machine Group `<Select>` most screens render; a screen with its own
 * distinct Machine Group styling (rounded corners, a different accent
 * color, etc.) can pass `formControlSx`/`labelSx`/`selectSx`/`checkboxSx` to
 * match it exactly instead of the defaults below.
 */
export default function PlantFilterSelect({
  plantOptions,
  selectedPlants,
  onChange,
  formControlSx,
  labelSx,
  selectSx,
  checkboxSx,
}) {
  return (
    <FormControl
      size="small"
      sx={formControlSx || defaultFormControlSx}
    >
      <InputLabel sx={labelSx || defaultLabelSx}>Plant</InputLabel>
      <Select
        multiple
        value={selectedPlants}
        onChange={(e) => onChange(e.target.value)}
        label={labelSx ? "Plant" : undefined}
        renderValue={(selected) => {
          if (selected.length === plantOptions.length) return "All Plants";
          if (selected.length === 0) return "Select Plants";
          return selected
            .map((code) => plantOptions.find((p) => p.value === code)?.label || code)
            .join(", ");
        }}
        sx={selectSx}
      >
        <MenuItem value="all">
          <Checkbox
            sx={checkboxSx || defaultCheckboxSx}
            checked={selectedPlants.length === plantOptions.length}
          />
          <ListItemText primary="All" />
        </MenuItem>
        {plantOptions.map((plant) => (
          <MenuItem key={plant.value} value={plant.value}>
            <Checkbox
              checked={selectedPlants.includes(plant.value)}
              sx={checkboxSx || defaultCheckboxSx}
            />
            <ListItemText primary={plant.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
